import { useEffect, useState } from "react";
import { Bell, Share, PlusSquare, Smartphone, Download } from "lucide-react";
import { toast } from "sonner";
import { useConfig } from "@/lib/data";
import { enablePush, isIOS, isStandalone } from "@/lib/media";

export function NotificationSetup() {
  const { data: cfg } = useConfig();
  const [state, setState] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const on = async () => {
    try {
      await enablePush(cfg?.vapid_public_key);
      setState("granted");
      toast.success("Notificações ativadas!");
    } catch (e) {
      toast.error(e.message);
    }
  };
  return (
    <div className="po-card" data-testid="notification-setup">
      <div className="flex items-center gap-3">
        <Bell className="h-7 w-7 text-orange-500" />
        <h3 className="text-xl font-bold text-slate-900">Avisos de novos pedidos</h3>
      </div>
      <p className="mt-2 text-base text-slate-700">Ative as notificações para saber na hora quando chegar um pedido perto de você. Também avisamos por e-mail.</p>
      {state === "granted" ? (
        <p className="mt-3 rounded-2xl bg-green-50 p-3 text-base font-semibold text-green-800" data-testid="notification-enabled">Notificações ativadas neste aparelho.</p>
      ) : (
        <button onClick={on} className="po-btn-primary mt-4 w-full" data-testid="enable-notifications-button">
          <Bell className="h-6 w-6" /> Ativar notificações
        </button>
      )}
      <InstallHelp />
    </div>
  );
}

export function InstallHelp() {
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (isStandalone()) return null;
  return (
    <div className="mt-5 rounded-2xl bg-orange-50 p-4" data-testid="install-help">
      <p className="flex items-center gap-2 text-lg font-bold text-slate-900"><Smartphone className="h-6 w-6 text-orange-600" /> Instale na tela inicial</p>
      {prompt && (
        <button onClick={() => prompt.prompt()} className="po-btn-dark mt-3 w-full" data-testid="install-app-button">
          <Download className="h-5 w-5" /> Instalar aplicativo
        </button>
      )}
      <p className="mt-3 text-base font-semibold text-slate-800">{isIOS() ? "No seu iPhone:" : "No iPhone:"}</p>
      <ol className="mt-1 space-y-2 text-base text-slate-700">
        <li className="flex gap-2"><b>1.</b> Abra este site no <b>Safari</b>.</li>
        <li className="flex gap-2"><b>2.</b> Toque em <Share className="inline h-5 w-5" /> <b>Compartilhar</b> (embaixo da tela).</li>
        <li className="flex gap-2"><b>3.</b> Toque em <PlusSquare className="inline h-5 w-5" /> <b>Adicionar à Tela de Início</b>.</li>
        <li className="flex gap-2"><b>4.</b> Abra pelo ícone laranja e toque em <b>Ativar notificações</b>.</li>
      </ol>
      <p className="mt-3 text-base text-slate-700"><b>No Android:</b> toque no menu ⋮ do Chrome e em <b>Instalar app</b>.</p>
    </div>
  );
}
